<template>
  <div>
    <ImageCarouselEvent />
  </div>
</template>

<script>
import ImageCarouselEvent from './ImageCarouselEvent.vue';
import { useHead } from '@vueuse/head';





export default {
  name: 'OfferEventPage',
  components: {
    ImageCarouselEvent
  },
  setup() {
    useHead({
      title: 'Oferta eventowa',
      meta: [
        {
          name: 'description',
          content: 'Obsługa eventów firmowych, brand experience, imprez masowych i okolicznościowych. Cocktail Service zapewnia mobilne bary, autorskie koktajle i kompleksowe zaplecze w całej Polsce.'
        },
        {
          property: 'og:title',
          content: 'Oferta eventowa | Cocktail Service'
        },
        {
          property: 'og:description',
          content: 'Kompleksowa oferta eventowa: obsługa barmańska, mobilne bary i wsparcie logistyczne dla wydarzeń w całej Polsce.'
        },
        {
          property: 'og:image',
          content: 'https://www.cocktailservice.pl/img/OFERTA-EVENTOWA-6.63441727.webp'
        },
        {
          property: 'og:url',
          content: 'https://www.cocktailservice.pl/event'
        }
      ]
    });
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body,
html {
  height: 100%;
}
</style>